<template>
  <div>
	  	<div v-if="$route.name === 'survey-list'">
			<polls-state-filter
				v-if="isEmployee"
				:state="state"
				@input="changeDiagnosisState"
			/>
			<poll-table 
				:rows="rows"
				:columns="columns"
				:no-actions="state === 2"
				@on-click="goToPoll"
				@on-search="onSearch"
			/>
		</div>
		<router-view name="pollResolve"></router-view>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import pollTable from '@/components/polls/poll-table';
import pollsStateFilter from '@/components/polls/polls-state-filter';
import { format } from 'date-fns';

function created() {
	this.listPolls();
}

async function listPolls() {
	try {
		const query = {
			state: this.state,
		};
		const response = await this.$http.get('poll-employees/diagnostic', { params: query });
		this.rows = response.data.map((r) => {
			const newR = { ...r };
			newR.diagnosticStartDate = r.diagnostic ?
				format(r.diagnostic.startDate, 'YYYY-MM-DD') : null;
			newR.diagnosticEndDate = r.diagnostic ?
				format(r.diagnostic.endDate, 'YYYY-MM-DD') : null;
			return newR;
		});
	} catch (error) {
		this.showGenericError();
	}
}

function onSearch(searchVal) {
	const newSearch = searchVal ? searchVal.trim() : null;
	this.search = newSearch;
}

function goToPoll(id) {
	this.goTo('page-polls', { params: { id } });
}

function changeDiagnosisState(state) {
	this.state = state;
	this.listPolls();
}

function data() {
	return {
		search: null,
		rows: [],
		columns: [
			{
				id: 1,
				name: 'Nombre de encuesta',
				value: 'name',
				checked: true,
				visible: true,
			},
			{
				id: 2,
				name: 'Puntos',
				value: 'points',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'Fecha Inicio',
				value: 'initDate',
				checked: true,
				visible: true,
			},
			{
				id: 4,
				name: 'Fecha Fin',
				value: 'finalDate',
				checked: true,
				visible: true,
			},
			{
				id: 5,
				name: 'Acciones',
				value: 'actions',
				checked: true,
				visible: true,
			},
		],
		state: 1,
	};
}

export default {
	name: 'page-poll',
	components: {
		pollsStateFilter,
		pollTable,
	},
	computed: {
		...mapState({
			isEmployee: state => state.user.isEmployee,
		}),
	},
	data,
	methods: {
		changeDiagnosisState,
		goToPoll,
		listPolls,
		onSearch,
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'survey') {
					this.listPolls();
				}
			}
		},
	},
	created,
};
</script>


// WEBPACK FOOTER //
// src/pages/polls/page-poll.vue